import { PropsWithChildren } from 'react'

type BlurredProps = {
  className: string
}
export default function Blurred({ className, children }: PropsWithChildren<BlurredProps>): JSX.Element {
  return (
    <div className={`rounded-full px-3 py-2 sm:px-5 sm:py-3 backdrop-blur-md blurred-item-border ${className ?? ''}`}>
      {children}
    </div>
  )
}
